export default "__VITE_PUBLIC_ASSET__e5c58da8__"